import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { LoginService } from './login.service';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private isLoggedInSubject = new BehaviorSubject<boolean>(false);
  public isLoggedIn$: Observable<boolean> = this.isLoggedInSubject.asObservable();

  constructor(private loginService: LoginService) {}

  checkAuthentication(): Observable<boolean> {
    return this.loginService.verifyToken().pipe(
      map(response => {
        const isValid = !!response?.data;
        this.isLoggedInSubject.next(isValid);
        return isValid;
      }),
      catchError(() => {
        this.isLoggedInSubject.next(false);
        return of(false);
      })
    );
  }
}
